import { Component } from '@angular/core';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FieldTypeListSimpleComponent } from '../field-type-list/field-type-list-simple/field-type-list-simple.component';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
  selector: 'change-state-process-modal',
  standalone: true,
  imports: [
    AfTranslateDirective,
    FieldTypeListSimpleComponent
  ],
  templateUrl: './change-state-process-modal.component.html'
})
export class ChangeStateProcessModalComponent {
  configuration: any = this.dialogConfig.data;
  nextStateFieldInfo: any = this.dialogConfig.data.nextStateFieldInfo;
  stateTransitionsList: any = this.dialogConfig.data.stateTransitionsList;
  nextStateSelected: any = this.dialogConfig.data.nextStateSelected;
  activeButton: string = this.dialogConfig.data.activeButton;

  constructor (
    private dialogRef: DynamicDialogRef<ChangeStateProcessModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private translate: AfTranslateFactory,
    private modalService: ModalServiceService
  ) { }

  selectItem(newValue: any) {
    this.nextStateSelected = newValue;
  }

  handleDismiss() {
    this.dialogRef.close({ result: 'cancel' });
  }

  handleAccept() {
    // Validate form
    if (this.nextStateSelected == null || isNaN(this.nextStateSelected)) {
      this.nextStateFieldInfo.error = this.translate.instant('common.error-required');
      this.modalService.errorModal({ text: this.translate.instant('states-process.transition-config-invalid') });
      return;
    }

    this.dialogRef.close({
      result: 'ok',
      nextStateSelected: this.nextStateSelected
    });
  }
}
